export const Disclaimer = ({ Text, Link }) => (
  <Text>
    By connecting your wallet, you agree to the{' '}
    <Link href="/terms-and-conditions">Terms and Conditions</Link> and
    acknowledge you have read and understand the{' '}
    <Link href="/data-protection">Data Protection</Link>
  </Text>
);
